import axios from '../../../service/index'
import React, { Component } from 'react'
import {getParams} from "../../../commponents/js/index"
import { message, Button, Form, Input, Icon, Spin } from 'antd'
// import infoimg from "../../../assets/images/live_bgimg.png"
import codeimg from "../../../assets/images/security_code.png"
import phoneimg from "../../../assets/images/phone.png"

import './Apply.less'
class Apply extends Component {
  constructor(props){
    super(props)
    document.title = '芯源互联'
  }
  state = {
    userId: '',
    codeUserId: '',
    stateobj: '',
    loading: false,
    telCode: '',
    phone: '',
    subjectId: '',
    btnDisable: false,
    btnText: '获取短信验证码',
    timeObj: '',
    yztime: 60
  }
  componentDidMount() {
    document.title = '芯源互联'
    if(window.location.search&&getParams(window.location.search).userId){
      this.linkAuthtj() // 授权获取userId
    }else if(window.location.search&&getParams(window.location.search).code){
      this.getUserIdCode() // 获取code
    }
  }
  componentWillUnmount() {
    clearInterval(this.state.timeObj)
  }
  getUserIdCode() {
    let code = getParams(window.location.search).code
    this.setState({stateobj: getParams(window.location.search).state})
    axios.get(`wxAuth/api/getUserId/${code}`).then(res => {
      this.setState({codeUserId: res.data.data})
    })
  }
  linkAuthtj() {
    let userId = getParams(window.location.search).userId
    let xetId = getParams(window.location.search).xetId
    let formdata = new FormData()
    formdata.append('userId', userId)
    formdata.append('xetId', xetId)
    axios.post('wxAuth/api/authurltj', formdata).then(res => {
      this.setState({loading: false})
      if(res.data.code === '200'){
        window.location.href=res.data.data
      }
    })
  }
  getMobileCaptchaForRegister = () => {
    if (!this.state.phone) return message.error('请输入手机号')
    axios.post(`activityxet/sendSms/${this.state.phone}`).then(res => {
      console.log(res)
      if(res.data.code !== '200')return message.error(res.data.msg)
      message.success(res.data.msg)
    })
    let {yztime} = this.state
    let timeObj = setInterval(() => {
      this.setState({
        yztime: yztime--,
        btnText: yztime+'秒后重新获取',
        btnDisable: true
      },() => {
        if(yztime<=0){
          this.setState({
            btnText: '获取短信验证码',
            btnDisable: false,
            yztime: 60
          })
          clearInterval(timeObj)
          return
        }
      })
    }, 1000)
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(!err){
        console.log(values)
        let {stateobj} = this.state
        let format = {
          activityId: stateobj.split('ASB')[1]||'',
          qyuserId: stateobj.split('ASB')[0]||'',
          userId: this.state.codeUserId,
          telCode: values.telCode,
          userPhone: values.phone
        }
        this.setState({loading: true})
        axios.post('wxqyuseruser/save',format).then(res => {
          if(res.data.code === '200') {
            message.success('提交成功')
            this.props.form.resetFields()
            let u = navigator.userAgent
            let android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
            let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            if(android){
              window.open(res.data.data)
            }else if(ios) {
              window.location.href = res.data.data
            }else{
              window.open(res.data.data)
            }
          }else{
            this.setState({loading: false})
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  selectChange(e) {
    this.setState({subjectId: e})
  }
  phoneValidateForm = (rule, value, callback) => {
    let rules = /^1(3|4|5|6|7|8|9)\d{9}$/
    if(value&&!rules.test(value)){
      callback('请输入正确的手机号')
    }else{
      callback()
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }}></Icon>
    return (
      <div className="Apply">
        {/*<img src={infoimg} className="info-img" alt=""/>*/}
        <div className="out-bg">


        <div className="form-content">
          <h3>免费听课，立即预约</h3>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item>
              {getFieldDecorator('phone', {
                rules: [
                  { required: true, message: '请输入手机号' },
                  { validator: this.phoneValidateForm }
              ],
              })(
                <div>
                  <Input onChange={(e) => {
                    this.setState({
                        phone: e.target.value
                    })
                  }}
                    allowClear
                    placeholder="请输入手机号"
                  />
                  <img className="code-icon phone-icon" src={phoneimg} alt="" />
                </div>
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('telCode', {
                rules: [{ required: true, message: '请输入验证码' }],
              })(
                <div className="telValidateCode">
                  <Input
                    allowClear
                    maxLength="6"
                    placeholder="请输入验证码"
                  />
                  <img className="code-icon" src={codeimg} alt=""/>
                  <Button type="primary"
                    size="small"
                    className="getPhoneCode"
                    disabled={this.state.btnDisable}
                    onClick={this.getMobileCaptchaForRegister}>{this.state.btnText}
                  </Button>
                </div>
              )}
            </Form.Item>
            <Form.Item>
              <Spin indicator={antIcon} spinning={this.state.loading}>
                <Button type="primary" htmlType="submit" className="look-btn">
                  观看直播
                </Button>
              </Spin>
            </Form.Item>
          </Form>
        </div>
        </div>
      </div>
    )
  }
}
export default Form.create()(Apply)
